import { useState, useMemo } from 'react'

export function useFilters<T>(data: T[]) {
  const [filters, setFilters] = useState<Record<string, any>>({})

  const setFilter = (key: string, value: any) => {
    setFilters((prev) => {
      const newFilters = { ...prev, [key]: value }
      if (value === '' || value === 'all' || value === null) {
        delete newFilters[key]
      }
      return newFilters
    })
  }

  const clearFilters = () => setFilters({})

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (!value) return true

        // Handle array values (multi-select)
        if (Array.isArray(item[key as keyof T])) {
          const itemValue = item[key as keyof T] as unknown as string[]
          return itemValue.includes(value)
        }

        // Handle exact matches
        return String(item[key as keyof T]) === String(value)
      })
    })
  }, [data, filters])

  return {
    filters,
    setFilter,
    clearFilters,
    filteredData,
    activeFilterCount: Object.keys(filters).length,
  }
}
